<template>
  <CFlex justify="space-between" width="100%" data-cy="sac-status-tile">
    <CFlex align="center" width="100%">
      <CPseudoBox :bg="color" w="8px" h="8px" borderRadius="50%" mr="8px" />
      <OmtTypography as="p1" mr="8px">
        {{ label }}
      </OmtTypography>
    </CFlex>
  </CFlex>
</template>

<script>
/**
 * @prop { String } color
 * @prop { String } label
 */
export default {
  props: {
    color: {
      type: String
    },
    label: {
      type: String
    }
  }
};
</script>
